import React, { useEffect, useState } from "react";
import { Button, Modal, Spin, Typography } from "antd";
import { Notify } from "../../utils/constants";
import { getLatestTermsAndConditions } from "../../utils/termsService";

type TermsAndConditionsModalProps = {
  open: boolean;
  onAccept: () => Promise<void>;
  onDecline: () => void;
};

const TermsAndConditionsModal = ({
  open,
  onAccept,
  onDecline,
}: TermsAndConditionsModalProps) => {
  const [termsText, setTermsText] = useState<string>("");
  const [isFetchingTerms, setIsFetchingTerms] = useState<boolean>(false);
  const [isAccepting, setIsAccepting] = useState<boolean>(false);

  useEffect(() => {
    if (!open) {
      return;
    }

    const fetchTerms = async () => {
      setIsFetchingTerms(true);
      try {
        const latestTerms = await getLatestTermsAndConditions();
        setTermsText(
          latestTerms?.text ||
            "No terms and conditions are currently configured.",
        );
      } catch (error) {
        console.error("Failed to fetch terms and conditions:", error);
        setTermsText("Failed to load terms and conditions.");
        Notify("error", "Could not load Terms and Conditions.");
      } finally {
        setIsFetchingTerms(false);
      }
    };

    fetchTerms();
  }, [open]);

  const handleAccept = async () => {
    try {
      setIsAccepting(true);
      await onAccept();
    } catch (error) {
      console.error("Failed to accept terms:", error);
      Notify("error", "Could not save Terms and Conditions acceptance.");
    } finally {
      setIsAccepting(false);
    }
  };

  return (
    <Modal
      title="Terms and Conditions"
      open={open}
      mask={{ closable: false }}
      keyboard={false}
      closable={false}
      footer={[
        <Button key="decline" onClick={onDecline}>
          Decline
        </Button>,
        <Button
          key="accept"
          type="primary"
          onClick={handleAccept}
          loading={isAccepting}
          disabled={isFetchingTerms}
        >
          I Agree
        </Button>,
      ]}
    >
      {isFetchingTerms ? (
        <Spin />
      ) : (
        <>
          <Typography.Paragraph>
            Please review and accept the Terms and Conditions to continue using
            the HolidayApp.
          </Typography.Paragraph>
          <Typography.Paragraph style={{ whiteSpace: "pre-wrap" }}>
            {termsText}
          </Typography.Paragraph>
        </>
      )}
    </Modal>
  );
};

export default TermsAndConditionsModal;
